import { button } from '../../../../../component/component'

import insertMarker from '../../../lib/insertMarker'
import insertMulti from '../../../lib/insertMulti'
import insertUserMarker from '../../../lib/insertUserMarker'

export default function(o,c){

  var click = function(e){
    if(o.store('role') == "admin" || o.store('role') == "author"){
      insertMarker(e, o, div)
    } else {
      insertUserMarker(e, o, div)
    }
  }

  var rightClick = function(e){
    insertMulti(e, o, div)
  }

  var div =
    button(null,'fi-plus')
    .css({
      position: 'absolute',
      right: '34px',
      top: 0,
    })
    .click(click)
    .contextmenu(rightClick)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/insert/insert.js